"use strict";
/**
 * Предоставляет инструменты для работы со сессионным хранилищем (sessionStorage).
 *
 * @namespace WebAccess.cache.sessionCache
 * @since 5.1.0.1534
 */
(function (global) {
  var ServerCache = global.cache.Cache.extend({
    init: function (data) {
      this._super(data);
    },

    /** 
    * Проверить, поддерживается ли браузером сессионное хранилище (sessionStorage).
    *
    * @function WebAccess.cache.sessionCache.isStorageAvailable
    * @since 5.1.0.1505
    * @return {boolean} True – сессионное хранилище поддерживается браузером, иначе False.
    */
    isStorageAvailable: function () {
      return !!(window["sessionStorage"]);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /** 
    * Удалить значение.
    *
    * @function WebAccess.cache.removeItem
    * @param {string} key Ключ кэш-хранилища     
    * @return {WebAccess.cache} Объект типа cache.
    * @since  5.1.0.1534 
    */
    removeItem: WA.TCD(function (key) {
      var me = this;
      try {
        this._getStorage().removeItem(key);
        this.fire('itemRemoved', key);
      } catch (e) {
        log.error('CACHE', e);
        me._errorCatched = true;
      }
      return this;
    }),
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /** 
    * Сохранить значение в кэш.
    *
    * @function WebAccess.cache.setItem
    * @param {string} key Ключ кэш-хранилища   
    * @param {string} value Сохраняемое значение. Объекты не сохраняются
    * @return {WebAccess.cache} Объект типа cache.
    * @since 5.0.0.7100
    */
    setItem: function (key, value) {
      var me = this;
      value = $.toJSON(value);
      return WA.SRV.call('/Session.asmx/SetUserProfileSettings', { ParamName: key, ParamValue: value }).done(function () {
        me.fire('itemSet', key, value);
      }).fail(function(e) {
        log.error('CACHE', e);
        me._errorCatched = true;
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить значение из кэша.
     *
     * @function WebAccess.cache.getItem
     * @param {string} key Ключ кэш-хранилища
     * @return {Deferred<Object>} Результат запроса.
     * @since 5.0.0.7100
     * @see https://api.jquery.com/category/deferred-object/
     */
    getItem: function (key) {
      var me = this;
      var result = $.Deferred();
      WA.SRV.call('/Session.asmx/GetUserProfileSettings', { ParamName: key }).done(function (value) {
        value = $.parseJSON(value);
        result.resolve(value);
      }).fail(function (e) {
        result.reject(e)
        log.error('CACHE', e);
        me._errorCatched = true;
      });
      return result;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    setObject: function(key,value) {
      return this.setItem(key, value);
    },

    getObject: function(key,value) {
      return this.getItem(key);
    },

    /**
    * @private 
    * @since 5.1.0.1505
    * @method WebAccess.cache.sessionCache._getStorage
    */
    _getStorage: function () {
      if (this.isStorageAvailable) return window.sessionStorage;
      else {
        console.warn('sessionCache is not available for this browser, using local variable instead');
        return this._data;
      }
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });
  global.cache.serverCache = new ServerCache();
})(window.WebAccess);